import genericAnnotationProperties from "./GenericAnnotationProperties";
export default genericAnnotationProperties({
  annotationType: "feature"
});
